import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function Bancos() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('banco', 'Banco'),
      Table.Field('idpropietario', 'Propietario'),
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('banco', 'banco', 'idbanco')
    )
  )
  
  return (
    <div>
      <h2>Bancos</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
